import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  name: 'BarChart',
}
